export const SITE_ROUTES = {
	HOME: "/",
	FEATURES: "/features",
	PRICING: "/pricing",
	ABOUT: "/about",
	CONTACT: "/contact",
	CAREERS: "/careers",
	PRIVACY: "/privacy",
	TERMS: "/terms",
	LEGAL_NOTICES: "/legal-notices",
} as const;
